import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

import {
  MatDialogConfig,
  MatDialogRef,
  MatDialog
} from "@angular/material/dialog";
import { Subject, Subscription } from "rxjs";
import {
  expectedColumnNames,
  UploadDialogData
} from "../upload-dialog/upload-dialog.typing";
import { ReferenceNameControllerService } from "../../../../services/reference-name-controller.service";
import { UploadDialogComponent } from "../upload-dialog/upload-dialog.component";
import * as FileSaver from "file-saver";
import { getDateDayMonthYear } from "../../../../services/format-date";
import { ReferenceSummary } from "../../../../models/reference-summary";
import { ContainerTypeControllerService } from "../../../../services/container-type-controller.service";
import { NavigationNoticeService } from "../../../../services/navigation-notice.service";
import { RecordRoute } from "../../../../services/record-route";
import { DeviceContainerControllerService } from "../../../../services/device-container-controller.service";
import { ProvisioningControllerService } from "../../../../services/provisionning-controller.service";
import { InfiniteScrollDirective } from "../../../../directives/infinite-scroll.directive";
import { SimpleDialogComponent } from "../../../../components/dialog/simple-dialog.component";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import ProvisioningState, {
  ViewProvisioningState
} from "../../../../models/provisioning-state";
import { NotificationService } from "../../../../services/notification.service";
import { MatMenuTrigger, MatMenu } from "@angular/material/menu";
import { ManagerListComponent } from "../utils/manager-list/manager-list.component";
import { FormsModule } from "@angular/forms";
import { MatIcon } from "@angular/material/icon";
import { NgStyle } from "@angular/common";
import { ButtonComponent } from "../../../elements/button/button.component";
import { FileUploaderComponent } from "../utils/file-uploader/file-uploader.component";

export interface ChangeDevice {
  code: any;
  deviceId: string;
}

@Component({
  selector: "app-switch",
  templateUrl: "./switch.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./switch.component.scss"],
  imports: [
    ManagerListComponent,
    MatMenuTrigger,
    FormsModule,
    MatIcon,
    MatMenu,
    InfiniteScrollDirective,
    NgStyle,
    ButtonComponent,
    FileUploaderComponent,
    TranslateModule
  ]
})
export class SwitchComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  private readonly SWITCH_REFERENCE = "switch";
  public isForm: boolean = false;
  public dataLoading: boolean = false;
  public allDataFetched: boolean = false;

  private skip: number = 0;
  private limit: number = 25;
  private search: string;
  public searchValueUpdate = new Subject<string>();
  public isDetail: boolean = false;

  public deviceIds: string[] = [];
  private devices: any[] = [];
  private code: string;
  public isFormValid: boolean = false;
  public rejectedDevice: string[];
  public rejectedContainers: string[];
  public acceptedDevices: string[];
  public nonExistingCode: string[];
  public translationRejectedDevices: string;
  public translationAcceptedDevices: string;
  public translationRejectedContainers: string;
  public translationNonExistingCode: string;
  public translatedTitle: string;
  public provisioningStates: ViewProvisioningState[];
  public detailProvisioningStates: ProvisioningState[];
  public selectedProvisioningState: ProvisioningState;

  filterProvisioning: any = undefined;

  provisioningRequestParameter: any = {
    skip: 0,
    limit: 25,
    filter: {}
  };
  detailProvisioningRequestParameter: any = {
    skip: 0,
    limit: 25,
    filter: {}
  };

  public numberOfProvisioningStates: number;
  public numberOfDetailProvisioningStates: number;
  public filterProvisioningChanged: boolean = false;
  public filterDetailProvisioningChanged: boolean = false;

  objectCreated: any = {};
  @Output() newObject: EventEmitter<any> = new EventEmitter();
  @Output() formIsValid: EventEmitter<boolean> = new EventEmitter();

  @ViewChild(InfiniteScrollDirective) infiniteScroll: InfiniteScrollDirective;

  private readonly references: any = {
    Switch: this.SWITCH_REFERENCE
  };

  formConfig: any = {
    name: "Switch",
    title: "Tracker",
    inputs: [
      {
        property: "deviceIds",
        title: "deviceIds",
        type: "string",
        search_selector: true,
        choices: "",
        mandatory: true,
        visible: true
      },
      {
        property: "code",
        title: "code",
        type: "string",
        search_selector: true,
        choices: "",
        mandatory: true,
        visible: true
      }
    ]
  };

  private subscription: Subscription = new Subscription();
  /** The `/manager/trackers/:tracker_id` segment: showing one tracker. */
  private trackerRoute: RecordRoute;
  private rawFile: string;
  private dialogRef: MatDialogRef<UploadDialogComponent>;

  public isUploaded: boolean = false;
  public uploadMode: "Change" = "Change";
  public typeSelected: string = "Switch";
  public uploadDatas: any[];
  public fileName: string;
  public columnNames: string[];
  public referenceSummary: ReferenceSummary;
  public separatorError: boolean = false;
  public separatorErrorWarnings: string[] = [];

  private readonly notifier: NotificationService;

  selectedNav: string = "Information";

  public devicesList: any[] = [];

  public properties: any = {
    Switch: [{ property: "code" }, { property: "deviceId" }]
  };

  provisioningProperties: any[] = [
    {
      label: "deviceId",
      property: "deviceId",
      canBeFiltered: true,
      width: 10
    },
    {
      label: "changeDate",
      property: "changeDate",
      canBeFiltered: true,
      transform: "date",
      width: 20
    },
    {
      label: "newState",
      property: "newState",
      canBeFiltered: true,
      width: 10
    },
    {
      label: "user",
      property: "user",
      canBeFiltered: true,
      width: 10
    },
    {
      label: "containerType",
      property: "containerType",
      canBeFiltered: true,
      width: 10
    }
  ];

  detailProvisioningProperties: any[] = [
    {
      label: "deviceId",
      property: "deviceId",
      canBeFiltered: false,
      width: 10
    },
    {
      label: "changeDate",
      property: "changeDate",
      transform: "date"
    },
    {
      label: "newState",
      property: "newState",
      canBeFiltered: true,
      width: 10
    },
    {
      label: "user",
      property: "user",
      canBeFiltered: true,
      width: 10
    },
    {
      label: "newContainerType",
      property: "newContainerType",
      canBeFiltered: true,
      width: 10
    }
  ];

  /**
   * Constructor for the SwitchComponent.
   * @param referenceNameControllerService Service to manage reference names.
   * @param dialog Service to manage dialogs.
   * @param containerTypeControllerService Service to manage container types.
   * @param deviceContainerControllerService Service to manage device containers.
   * @param provisioningControllerService Service to manage provisioning.
   * @param translateService Service for translation.
   * @param notifierService Service for notifications.
   * @param route Current route, for reading the :tracker_id deep-link param.
   * @param router Router, used to reflect the selected tracker in the URL.
   */
  constructor(
    private referenceNameControllerService: ReferenceNameControllerService,
    public dialog: MatDialog,
    public containerTypeControllerService: ContainerTypeControllerService,
    public deviceContainerControllerService: DeviceContainerControllerService,
    public provisioningControllerService: ProvisioningControllerService,
    public translateService: TranslateService,
    private notifierService: NotificationService,
    private route: ActivatedRoute,
    private router: Router,
    private navigationNotice: NavigationNoticeService
  ) {
    this.notifier = notifierService;
    this.trackerRoute = new RecordRoute(
      this.route,
      this.router,
      this.navigationNotice,
      {
        paramKey: "tracker_id",
        basePath: ["/manager", "trackers"],
        open: (deviceId: string) => this.loadDetail(deviceId, true),
        close: () => this.resetDetail()
      }
    );
  }

  /**
   * Method called during component initialization.
   */
  ngOnInit() {
    this.getAllProvisioningStates();
    this.refreshTitle();
    this.searchValueUpdate
      .pipe(debounceTime(800), distinctUntilChanged())
      .subscribe((value) => {
        this.search = value;
        this.loadMore();
      });

    // Route-driven detail selection: /manager/trackers/:tracker_id (= deviceId)
    // opens that tracker's provisioning history; /manager/trackers shows the
    // list. Reacts to deep-links and browser back/forward.
    this.subscription.add(this.trackerRoute.follow());
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.provisioningRequestParameter.filter) {
      this.provisioningRequestParameter.filter =
        changes.provisioningRequestParameter.currentValue;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  /**
   * @description Get all data from view provisioning states
   * @returns void
   */
  public getAllProvisioningStates() {
    this.subscription.add(
      this.provisioningControllerService
        .getViewProvisioningStates(
          this.provisioningRequestParameter.skip,
          this.provisioningRequestParameter.limit,
          this.provisioningRequestParameter.filter
        )
        .subscribe((states) => {
          this.provisioningStates = states;
        })
    );
    this.getNumberOfProvisioningStates();
  }
  /**
   * @description Get the number of view provisioning states
   * @returns void
   */
  public getNumberOfProvisioningStates(): void {
    this.subscription.add(
      this.provisioningControllerService
        .countViewProvisioningStates(this.provisioningRequestParameter.filter)
        .subscribe((res) => {
          this.numberOfProvisioningStates = res.count;
        })
    );
  }

  changePage(event) {
    this.provisioningRequestParameter.limit = event.limit;
    this.provisioningRequestParameter.skip = (event.page - 1) * event.limit;
    this.updateProvisioningList(true);
  }

  changeFilter(event) {
    if (event === undefined) {
      this.provisioningRequestParameter.filter = undefined;
    } else {
      if (event.search !== undefined) {
        const filter: any = { or: [] };
        for (const prop of this.provisioningProperties) {
          if (prop.canBeFiltered) {
            const object: any = {};
            object[prop.property] = event.search;
            filter.or.push(object);
          }
        }
        this.provisioningRequestParameter.filter = filter;
      } else {
        this.provisioningRequestParameter.filter = { and: [event] };
      }
    }
    this.provisioningRequestParameter.skip = 0;
    this.updateProvisioningList(true);
  }
  /**
   * @description Updates the provisioning list.
   * @param isFilterChanged Indicates if the filter has changed.
   */
  updateProvisioningList(isFilterChanged?: boolean) {
    this.filterProvisioningChanged = isFilterChanged
      ? true
      : this.filterProvisioningChanged;

    this.getAllProvisioningStates();
    if (this.filterProvisioningChanged) {
      this.getNumberOfProvisioningStates();
    }
  }
  /**
   * @param file File to load.
   * @description Loads a file.
   */
  loadFile(file: File) {
    if (file) {
      let reader: FileReader = new FileReader();
      this.uploadDatas = [];
      this.isUploaded = true;
      reader.readAsText(file);
      reader.onload = (_e) => {
        let csv: string = reader.result as string;
        this.rawFile = csv;
        this.fileName = file.name;
        this.parseCSVData(csv);
      };
    }
  }

  private parseCSVData(csv: string) {
    let separator: string;
    let dataLines: string[] = csv.split("\r\n");
    this.separatorError = false;
    this.separatorErrorWarnings = [];
    let dataLinesError: Array<[number, string]> = [];
    dataLines = dataLines.length === 1 ? csv.split("\n") : dataLines;
    const columnNamesColon: string[] = dataLines[0].split(",");
    const columnNamesSemiColon: string[] = dataLines[0].split(";");
    separator =
      columnNamesSemiColon.length >= columnNamesColon.length ? ";" : ",";
    this.columnNames = dataLines[0].split(separator);
    dataLines.shift();
    let uploadDatas: string[][] = [];
    let props: string[];
    let count = 1;
    for (const dataLine of dataLines) {
      count += 1;
      if (dataLine.length > this.properties[this.typeSelected].length * 2) {
        props = dataLine.split(separator);
        if (props.length !== this.columnNames.length) {
          this.separatorError = true;
          dataLinesError.push([count, dataLine]);
        }
        uploadDatas.push(props);
      }
    }
    this.uploadDatas = uploadDatas;
  }

  /**
   * @description Refresh the title
   */
  public backOnList() {
    this.typeSelected = undefined;
    this.isUploaded = false;
    this.isForm = false;
    this.nonExistingCode = undefined;
    this.getAllProvisioningStates();
  }

  /**
   * @description Leave the detail view and go back to the tracker list.
   */
  public switchDetail() {
    // From a tracker URL, navigate back to the list (the route-param
    // subscription closes the detail); otherwise just close in place.
    this.trackerRoute.leave(() => this.resetDetail());
  }

  /**
   * @description Close the detail view and reset its paging/filter state.
   */
  private resetDetail() {
    this.isDetail = false;
    this.detailProvisioningRequestParameter.filter = {};
    this.detailProvisioningRequestParameter.skip = 0;
    this.detailProvisioningRequestParameter.limit = 25;
    this.selectedProvisioningState = undefined;
    this.detailProvisioningStates = undefined;
  }

  public doProvisioning() {
    this.updateContainerType(this.prepareDataFromCsv());
  }

  public triggerForm() {
    this.isForm = !this.isForm;
    if (this.isForm === true) {
      this.codeAndDevices();
    } else {
      this.resetFormData();
    }
  }
  /**
   * @description In form for input get the code and the devices
   */
  private codeAndDevices() {
    for (const input of this.formConfig.inputs) {
      if (input.property === "code") {
        this.subscription.add(
          this.containerTypeControllerService
            .getContainerTypes()
            .subscribe((res) => {
              input.choices = res
                .map(({ code }) => {
                  return code;
                })
                .sort();
              input.filteredOptions = input.choices;
            })
        );
      } else if (input.property === "deviceIds") {
        this.subscription.add(
          this.deviceContainerControllerService
            .getDeviceIdsFilter(this.skip, this.limit, this.search)
            .subscribe((res) => {
              this.devices = res;
              input.choices = this.devices;
              input.filteredOptions = res;
            })
        );
      }
    }
  }
  /**
   *
   * @param referenceNameId
   * @param text
   * @description Save the file and display the summary
   */
  saveFile(referenceNameId: string, text: string) {
    let concatWarnings = [];

    if (this.acceptedDevices) {
      this.translateService
        .get("manager.Reference.switch.acceptedDevices", {
          length: this.acceptedDevices.length
        })
        .subscribe((translation) => {
          this.translationAcceptedDevices = translation;
        });
    }
    if (this.rejectedDevice) {
      this.translateService
        .get("manager.Reference.switch.rejectedDevice", {
          length: this.rejectedDevice.length
        })
        .subscribe((translation) => {
          this.translationRejectedDevices = translation;
        });
      concatWarnings.push(this.translationRejectedDevices);
      concatWarnings.push(...this.rejectedDevice);
    }
    if (this.rejectedContainers) {
      this.translateService
        .get("manager.Reference.switch.rejectedContainers", {
          length: this.rejectedContainers.length
        })
        .subscribe((translation) => {
          this.translationRejectedContainers = translation;
        });
      concatWarnings.push(this.translationRejectedContainers);
      concatWarnings.push(...this.rejectedContainers);
    }

    if (this.nonExistingCode) {
      this.translateService
        .get("manager.Reference.switch.nonExistingCodes", {
          length: this.nonExistingCode.length
        })
        .subscribe((translation) => {
          this.translationNonExistingCode = translation;
        });
      concatWarnings.push(this.translationNonExistingCode);
      concatWarnings.push(...this.nonExistingCode);
    }

    this.subscription.add(
      this.referenceNameControllerService
        .createReferenceFile(
          { referenceNameId, uploadDate: Date.now() },
          text,
          this.uploadMode
        )
        .subscribe((_result) => {
          this.referenceSummary = new ReferenceSummary({});
          this.translateService
            .get("manager.Reference.info", { fileName: this.fileName })
            .subscribe((translation) => {
              if (this.acceptedDevices) {
                this.referenceSummary.info = [
                  translation,
                  this.translationAcceptedDevices,
                  ...this.acceptedDevices
                ];
              }
            });
          this.translateService
            .get("manager.Reference.detail", {
              uploadDatas: this.uploadDatas.length
            })
            .subscribe((translation) => {
              this.referenceSummary.details = [translation];
            });
          this.referenceSummary.warnings = concatWarnings;
        })
    );
  }

  public changeUploadMode(mode: "Change") {
    this.uploadMode = mode;
  }

  public downloadTemplate(referenceType: "Switch") {
    const csvContent = expectedColumnNames[referenceType].join(",") + "\r\n";
    const blob = new Blob([csvContent], { type: "text/csv" });
    FileSaver.saveAs(blob, `${referenceType}_${getDateDayMonthYear()}.csv`);
  }

  /**
   * @description open the dialog to upload a file
   */
  public async openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.hasBackdrop = true;

    this.dialogRef = this.dialog.open(UploadDialogComponent, {
      panelClass: "upload-dialog-container",
      autoFocus: false,
      data: {
        switchMode: true,
        previousRowNumber: undefined,
        loadFile: this.loadFile.bind(this),
        changeUploadMode: this.changeUploadMode.bind(this),
        referenceType: this.typeSelected
      } as UploadDialogData
    });
  }

  /**
   *
   * @param decodedData
   * @description Update the container type
   */
  private updateContainerType(decodedData: any) {
    this.subscription.add(
      this.provisioningControllerService
        .checkContainers(Object.keys(decodedData.devices))
        .subscribe((res) => {
          if (!res) {
            this.subscription.add(
              this.provisioningControllerService
                .update(decodedData)
                .subscribe((res) => {
                  this.acceptedDevices = res.devicesIds;
                  this.rejectedDevice = res.rejectedDevice;
                  this.rejectedContainers = res.rejectedContainers;
                  if (
                    this.rejectedContainers.length == 0 &&
                    this.rejectedDevice.length == 0
                  ) {
                    let data = {};
                    this.translateService
                      .get("dialogSwitch")
                      .subscribe((translations) => {
                        data = {
                          title: translations.title,
                          text: translations.description,
                          yes: translations.confirm
                        };
                      });
                    const dialogRef = this.dialog.open(SimpleDialogComponent, {
                      data
                    });
                    this.subscription.add(
                      dialogRef.afterClosed().subscribe((isConfirmed) => {
                        if (isConfirmed) {
                          this.triggerForm();
                          this.resetFormData();
                        }
                      })
                    );
                    const date: number = Date.now();
                    const userName: string = localStorage.getItem("username");
                    this.saveFile(
                      this.references[this.typeSelected],
                      this.rawFile
                    );
                    this.saveFile(
                      `reference:${userName}:${this.typeSelected}:${date}`,
                      this.rawFile
                    );
                  } else {
                    let data = {};
                    this.translateService
                      .get("dialogSwitchError")
                      .subscribe((translations) => {
                        data = {
                          title: translations.title,
                          text: translations.description,
                          yes: translations.confirm
                        };
                      });
                    const date: number = Date.now();
                    const userName: string = localStorage.getItem("username");
                    this.saveFile(
                      this.references[this.typeSelected],
                      this.rawFile
                    );
                    this.saveFile(
                      `reference:${userName}:${this.typeSelected}:${date}`,
                      this.rawFile
                    );
                    const dialogRef = this.dialog.open(SimpleDialogComponent, {
                      data
                    });
                    this.subscription.add(
                      dialogRef.afterClosed().subscribe((isConfirmed) => {
                        if (isConfirmed) {
                          this.isFormValid = false;
                          this.resetFormData();
                        }
                      })
                    );
                  }
                })
            );
          } else {
            let data = {};
            this.nonExistingCode = res;
            this.translateService.get("codeError").subscribe((translations) => {
              data = {
                title: translations.title,
                yes: translations.confirm
              };
            });
            this.translateService
              .get("codeError.description", {
                code: this.nonExistingCode.toString()
              })
              .subscribe((translation) => {
                data = {
                  ...data,
                  text: translation
                };
              });

            const date: number = Date.now();
            const userName: string = localStorage.getItem("username");
            this.saveFile(
              `reference:${userName}:${this.typeSelected}:${date}`,
              this.rawFile
            );
            const dialogRef = this.dialog.open(SimpleDialogComponent, {
              data
            });

            this.subscription.add(
              dialogRef.afterClosed().subscribe((isConfirmed) => {
                return isConfirmed;
              })
            );
          }
        })
    );
  }

  private resetFormData() {
    this.objectCreated = {};
    this.search = null;
    this.deleteList();
    this.formConfig.inputs.forEach((input) => {
      input.value = null;
      input.filter = null;
    });
    this.codeAndDevices();
  }
  /**
   *
   * @returns void
   * @description get the data from csv and prepare it for the update
   */
  private prepareDataFromCsv() {
    let dataDecode: ChangeDevice[] = [];

    //on récupère les données du fichier
    this.rawFile.split("\n").map((line, index) => {
      if (line.length > 0 && index > 0) {
        let charToSplit = line.includes(";") ? ";" : ",";
        let [code, deviceId] = line.split(charToSplit);
        deviceId = deviceId.replace("\r", "");
        dataDecode.push({ code, deviceId });
      }
    });

    //cette fonction permet de rassembler tous les devices par container : {code: [deviceId1, deviceId2, ...]}
    const groupBy = function (xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x.deviceId);
        return rv;
      }, {});
    };
    dataDecode.filter(this.onlyUnique);
    const devices = groupBy(dataDecode, "code");
    return { devices };
  }

  private prepareDataFromForm() {
    this.deviceIds = this.deviceIds.filter(this.onlyUnique);
    return { devices: { [this.code]: this.deviceIds } };
  }

  private onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  updateDataFromForm() {
    this.updateContainerType(this.prepareDataFromForm());
  }

  /**
   *
   * @description On scroll load more data
   */
  public loadMore = () => {
    for (const input of this.formConfig.inputs) {
      if (input.property === "deviceIds") {
        if (!this.dataLoading && !this.allDataFetched) {
          this.dataLoading = true;
          this.subscription.add(
            this.deviceContainerControllerService
              .getDeviceIdsFilter(this.skip, this.limit, this.search)
              .subscribe((res) => {
                input.choices = [...input.choices, ...res];
                input.filteredOptions = input.choices;
                this.devices = input.filteredOptions;
                this.skip += this.limit;
                this.dataLoading = false;
              })
          );
        }
      }
    }
  };

  /**
   *
   * @returns string[]
   * @description Update the match data source
   */
  public updateMatchDataSource(): string[] {
    return (this.devices = this.devices.filter(({ key }) => {
      if (typeof key === "string") {
        key = key.toUpperCase();
      } else if (typeof key === "number") {
        key = key.toString();
      }
      return key === this.search.toUpperCase();
    }));
  }

  changeArrow(input: any) {
    input.isOpen = input.isOpen ? false : true;
  }

  /**
   *
   * @param input
   * @description Request the data from the server to update the form select input
   */
  onFilterChange(input) {
    if (input.property !== "deviceIds") {
      input.filteredOptions = input.choices.filter((option) =>
        option.toLowerCase().includes(input.filter.toLowerCase())
      );
    } else {
      input.choices = [];
      this.skip = 0;
      this.limit = 100;
      this.search = input.filter.toUpperCase();
      this.searchValueUpdate.next(input.filter);
    }
  }
  /**
   *
   * @param choice
   * @param prop
   * @param index
   * @param input
   * @description Select the property of the form select input and update the object created
   */
  selectProp(choice, prop, index, input?) {
    this.objectCreated[prop] = choice;
    if (input?.search_selector) {
      if (choice === "") {
        this.objectCreated[prop] = input.choices[0];
      }
    }
    if (input.property === "deviceIds") {
      if (this.deviceIds.includes(choice)) {
        this.translateService
          .get("switch.deviceAlreadySelected", { device: choice })
          .subscribe((res) => {
            this.notifier.error(res);
          });
      } else {
        this.deviceIds.push(choice);
      }
      // reset the filter when tracker selected
      input.filter = "";
      this.trigger.closeMenu();
    }
    if (input.property === "code") {
      input.filter = choice;
      this.code = choice;
    }
    this.onValidateForm(index);
    this.refreshTitle();
  }

  /**
   *
   * @param event
   * @description Create object from the form
   */
  onValidateForm(event) {
    // removal of unnecessary spaces (beginning / end of string and duplicates between words)

    this.objectCreated[this.formConfig.inputs[event].property] =
      this.objectCreated[this.formConfig.inputs[event].property].trim();

    this.formConfig.inputs[event].value =
      this.objectCreated[this.formConfig.inputs[event].property];

    this.formConfig.inputs[event].valid = this.verifyInput(
      this.formConfig.inputs[event]
    );

    this.formIsValid.emit(this.checkWholeForm());
    this.newObject.emit(this.objectCreated);
  }

  /**
   *
   * @param input
   * @returns boolean
   * @description Verify the input validity
   */
  verifyInput(input: any): boolean {
    input.errorMsg = undefined;

    if (input.mandatory && this.objectCreated[input.property]) {
      if (input.validityConditions) {
        return this.verify(input);
      }
      return true;
    }
    if (!input.mandatory) {
      return true;
    }
    return false;
  }

  verify(input: any): boolean {
    let valid: boolean = true;
    let value = input.value;
    this.objectCreated[input.property] = value;
    for (const condition of input.validityConditions) {
      if (condition.type === "greater") {
        valid = Number(value) >= condition.value ? valid : false;
      }
      if (condition.type === "lower") {
        valid = Number(value) <= condition.value ? valid : false;
      }
      if (condition.type === "like") {
        valid = value.match(condition.value) ? valid : false;
      }
    }
    if (input.transform === "number") {
      this.objectCreated[input.property] = Number(value);
    }
    return valid;
  }
  /**
   *
   * @param element
   * @description Get all the provisioning states by id
   */
  getProvisioningStatesById(element: ProvisioningState) {
    // Navigation drives selection; the route-param subscription applies it.
    this.trackerRoute.goTo(element.deviceId);
  }

  /**
   *
   * @param deviceId Tracker to show the provisioning history of.
   * @param fromRoute True when the id came from the URL, in which case an
   * unknown tracker (no history at all, the filter being empty on a fresh
   * load) falls back to the list instead of showing an empty detail.
   * @description Fetch and display one tracker's provisioning history.
   */
  private loadDetail(deviceId: string, fromRoute: boolean = false) {
    this.selectedProvisioningState = { deviceId } as ProvisioningState;
    this.isDetail = true;
    this.subscription.add(
      this.provisioningControllerService
        .getProvisioningStatesById(
          this.detailProvisioningRequestParameter.skip,
          this.detailProvisioningRequestParameter.limit,
          this.detailProvisioningRequestParameter.filter,
          deviceId
        )
        .subscribe((states) => {
          this.dataLoading = false;
          if (fromRoute && (!states || !states.length)) {
            // Unknown tracker: notice + back to the list.
            this.trackerRoute.notFound();
            return;
          }
          this.detailProvisioningStates = states;
        })
    );
    this.getNumberOfDetailProvisioningStates();
  }
  /**
   * @description Get the number of detail provisioning states
   * @returns void
   */
  public getNumberOfDetailProvisioningStates(): void {
    this.subscription.add(
      this.provisioningControllerService
        .countProvisioningStatesById(
          this.detailProvisioningRequestParameter.filter,
          this.selectedProvisioningState.deviceId
        )
        .subscribe((res) => {
          this.numberOfDetailProvisioningStates = res.count;
        })
    );
  }

  /**
   *
   * @param event
   * @description Change the filter of the detail provisioning list
   */
  changeDetailFilter(event) {
    if (this.selectedProvisioningState !== undefined) {
      if (event === undefined) {
        this.detailProvisioningRequestParameter.filter = {
          where: {
            deviceId: this.selectedProvisioningState.deviceId
          }
        };
      } else {
        if (event.search !== undefined) {
          const filter: any = { or: [] };
          for (const prop of this.detailProvisioningProperties) {
            if (prop.canBeFiltered) {
              const object: any = {};
              object[prop.property] = event.search;
              filter.or.push(object);
            }
          }
          this.detailProvisioningRequestParameter.filter = {
            and: [
              { or: filter.or },
              { deviceId: this.selectedProvisioningState.deviceId }
            ]
          };
        } else {
          this.detailProvisioningRequestParameter.filter = { and: [event] };
        }
      }
      this.provisioningRequestParameter.skip = 0;
      this.updateDetailProvisioningList(true);
    }
  }

  /**
   *
   * @param isFilterChanged
   * @description Update the list of provisioning states with the new filter
   */
  updateDetailProvisioningList(isFilterChanged?: boolean) {
    this.filterDetailProvisioningChanged = isFilterChanged
      ? true
      : this.filterDetailProvisioningChanged;

    this.loadDetail(this.selectedProvisioningState.deviceId);
    if (this.filterDetailProvisioningChanged) {
      this.getNumberOfDetailProvisioningStates();
    }
  }

  /**
   * @param event
   * @description Change the page of the detail provisioning list
   * @returns void
   */
  changeDetailPage(event) {
    this.detailProvisioningRequestParameter.limit = event.limit;
    this.detailProvisioningRequestParameter.skip =
      (event.page - 1) * event.limit;
    this.updateDetailProvisioningList(true);
  }

  deleteList() {
    this.deviceIds = [];
    this.refreshTitle();
    this.checkWholeForm();
  }
  /**
   *
   * @returns void
   * @description Check if the form is valid
   */
  checkWholeForm() {
    let isValid: boolean = true;
    for (const input of this.formConfig.inputs) {
      if (input.property === "code" && !input.value) {
        isValid = false;
      }
    }

    if (this.deviceIds.length === 0) {
      isValid = false;
    }
    this.isFormValid = isValid;
    return isValid;
  }

  private deleteDevice(index: number) {
    this.deviceIds.splice(index, 1);
    this.refreshTitle();
    this.checkWholeForm();
  }
  /**
   * @description Refresh the title of the form
   * @returns void
   */
  refreshTitle() {
    this.translateService
      .stream("manager.Devices.deviceList", {
        length: this.deviceIds.length
      })
      .subscribe((res) => {
        this.translatedTitle = res;
      });
  }
}
